<template>
    <div class="story-maker-sticker story-maker-sticker-link">
        <img class="img-change-color" :src="require('../../../../../assets/img/instagram/ehf.png')">
        <p class="text-finish">Terminé</p>
        <div class="sticker-link" :class="`style${styleVariant}`">
           <div class="icon"></div>
            <p>{{ text || link }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: Number | String,
            link: String,
            text: String,
            styleVariant: Number,
            setCbClick: Function,
        },

        mounted () {
            if (this.setCbClick) this.setCbClick(this.changeStyleVariant);
        },
        methods: {
            changeStyleVariant(e) {
                this.$emit('updateSticker',this.id , {
                    data : {
                        link : this.link,
                        text : this.text,
                        styleVariant :(this.styleVariant % 6) + 1
                    },
                })
            }
        },
    }
</script>
